export enum AuthenticationActionTypes {
  CHANGE_AUTH_DATA = 'CHANGE_AUTH_DATA',
  RESET_USER_DATA = 'RESET_USER_DATA',
  LOGOUT_HANDLE = 'LOGOUT_HANDLE',
  CHANGE_NORMAL_LOGIN_FLOW_STEP = 'CHANGE_NORMAL_LOGIN_FLOW_STEP',
  TOGGLE_IS_FROM_DOCUMENTAION_LOGIN = 'TOGGLE_IS_FROM_DOCUMENTAION_LOGIN',
}
